const maintenanceButtonEquip = {
  true: 'Regresar de',
  false: 'Enviar para',
  label: 'Mantenimiento'
};

export default maintenanceButtonEquip;
